import {trans} from "../app";
import moment from "moment";
import {FORMAT_DATE, SYSTEM_DATE} from "./dateFormatter";

class RulesBuilder {
    constructor() {
        this.reset();
    }

    addIsIntegerRule(field) {
        this.rules.push(v => !v || (v - v === 0 && v.toString().indexOf('.') === -1 && v.toString().indexOf(',') === -1) || trans('validation.integer', {attribute: field}));

        return this;
    }

    addIsNumericRule(field) {
        this.rules.push(v => !v || isNaN(v) === false || trans('validation.numeric', {attribute: field}));

        return this;
    }

    addNumberBiggerThanRule(field, number) {
        this.rules.push(
            v => !v || +number <= v || trans('validation.min.numeric', {attribute: field, min: number})
        );

        return this;
    }

    addNumberBetweenRule(field, min, max) {
        this.rules.push(
            v => !v || (+min <= v && +max >= v) || trans('validation.between.numeric', {attribute: field, min, max})
        );

        return this;
    }

    addMaxLengthRule(field, max) {
        this.rules.push(
            v => !(v && v.length > max) || trans('validation.max.string', {attribute: field, max})
        );

        return this;
    }

    addMinLengthRule(field, min, isArray = false) {
        const key = isArray ? 'validation.min.array' : 'validation.min.string';
        this.rules.push(
            v => !(v && v.length < min) || trans(key, {attribute: field, min})
        );

        return this;
    }


    addRequiredRule(field) {
        this.rules.push(v => (!!v || v === 0) || trans('validation.required', {attribute: field}));

        return this;
    }

    addConfirmCheckboxRule(field) {
        this.rules.push(v => !!v || trans('validation.accepted', {attribute: field}));

        return this;
    }

    addTimeRule(field) {
        this.rules.push(
            v => !!v || trans('validation.required', {'attribute': field})
        );
        this.rules.push(
            v => /([01]\d|2[0-3]):[0-5]\d/.test(v) || trans('validation.regex', {
                attribute: field,
            })
        );

        return this;
    }

    addDateFormatRule(field, dateFormat) {
        this.rules.push(
            v => moment(v, dateFormat)._isValid || trans('validation.date_format', {
                attribute: field,
                format: dateFormat,
            })
        );

        return this;
    }

    allowEmptyRule() {
        this.nullable = true;

        return this;
    }

    addIsEmailRule(field) {
        this.rules.push(
            v => !(v && !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v)) || trans('validation.email', {
                attribute: field
            })
        );

        return this;
    }

    addIsValidDate(field, format = null) {
        this.rules.push(
            v => {
                let result;
                if (null !== format) {
                    result = moment(v, format)._isValid;
                } else {
                    result = !isNaN(Date.parse(v));
                }

                return result || trans('validation.date', {
                    attribute: field
                });
            }
        );

        return this;
    }

    addDateIsAfter(field, otherField, otherDate, dateFormat = FORMAT_DATE, otherDateFormat = SYSTEM_DATE) {
        this.rules.push(
            v => moment(v, dateFormat).isAfter(moment(otherDate, otherDateFormat)) || trans('validation.date_is_after', {
                attribute: field,
                other: otherField
            })
        );

        return this;
    }

    addDateIsBefore(field, otherField, otherDate, dateFormat = FORMAT_DATE, otherDateFormat = SYSTEM_DATE) {
        this.rules.push(
            v => moment(v, dateFormat).isBefore(moment(otherDate, otherDateFormat)) || trans('validation.date_is_before', {
                attribute: field,
                other: otherField
            })
        );

        return this;
    }

    addTimeIsBefore(time) {
        this.rules.push(
            v => v === time || moment(`2020-01-01 ${time}`).isAfter(moment(`2020-01-01 ${v}`)) || trans('validation.time_is_after')
        );

        return this;
    }

    addTimeIsAfter(time) {
        this.rules.push(
            v => v === time || moment(`2020-01-01 ${v}`).isAfter(moment(`2020-01-01 ${time}`)) || trans('validation.time_is_after')
        );

        return this;
    }

    addIsTimeRule(field) {
        this.rules.push(
            v => /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(v) || trans('validation.time', {
                attribute: field
            })
        );

        return this;
    }

    addSameRule(field, otherField, otherValue) {
        this.rules.push(
            v =>  {
                return v === otherValue || trans('validation.same', {
                    attribute: field,
                    other: otherField,
                });
            }
        );

        return this;
    }

    getRules() {
        let rules = this.rules;
        if (this.nullable) {
            const allowEmpty = v => (!v) === true;
            rules = this.rules
                .map(validateFunction => value => {
                    if (allowEmpty(value)) {
                        return true;
                    }

                    return validateFunction(value);
                });
        }

        this.reset();

        return rules;
    }

    reset() {
        this.rules = [];
        this.nullable = false;
    }
}

export default RulesBuilder;
